import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import { H3, P, Description } from "../components/typography";
import { withState } from "recompose";
import { getGraphNode } from "../selectors";
import NavBar from "../components/NavBar";
import AspectImage from "../components/atoms/AspectImage";
import Quote from "../components/HeroQuote";
import Pad from "../components/blocks/Pad";
import Flex, { HFlexFlipper } from "../components/blocks/Flex";
import { HideDesktop, ShowMobile } from "../components/blocks/Responsive";
import Spacer from "../components/blocks/Spacer";
import Background from "../components/blocks/Background";
import ContentSection from "../components/blocks/ContentSection";
import Section from "../components/blocks/Section";
import Couple from "../components/Couple";
import Card from "../components/PictureCard";
import Waypoint from "react-waypoint";
import HeroMission from "../components/HeroMission";
import favicon from "../../assets/logofavcon@2x.png";
import theme from "../styles/theme";
import Image from "../components/Image";
import ArrowLink from "../components/ArrowLink";

const FadeOut = styled.div`
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 1s;
`;

const HeroImageWrapper = styled(Pad)`
  flex: 5;
  margin-left: 0rem;

  ${props => props.theme.media.tablet`
    margin-left: 0rem;
    padding-right: 3rem;
  `};
`;

const HeroText = styled.div`
  flex: 5;
  padding-left: 6rem;

  ${props => props.theme.media.tablet`
    padding-left: 1rem;
    padding-right: 1rem;
  `};
`;

const TrialPage = ({ background, onColorChange, data }) => {
  console.log(data);
  const content = getGraphNode(data, "TrialPage");
  return (
    <div>
      <Background>
        <Helmet
          title="Clinical Trials"
          meta={[{ name: "Contraline", content: "Trials" }]}
        >
          <link rel="icon" type="image/png" href={favicon} />
        </Helmet>
        <NavBar color="dark" />
        <Section v={8}>
          <HFlexFlipper>
            <HeroImageWrapper h={1} mh={0.5} style={{ paddingLeft: 0 }}>
              <Image
                full={true}
                align="center"
                caption={""}
                image={content.heroImage.responsiveResolution.src}
              />
            </HeroImageWrapper>
            <ShowMobile>
              <Spacer span={3} />
            </ShowMobile>
            <HeroText>
              <H3>
                {content.heroTitle}
              </H3>
              <P>
                {content.heroBody.heroBody}
              </P>
              <Spacer span={0.5} />
              <Description>
                {content.heroLink &&
                  <Pad v={0.75}>
                    <ArrowLink color={"teal"} to={"https://theadamstudy.com"}>
                      <P color={"teal"} style={{ paddingBottom: 0 }}>
                        {content.heroLink}
                      </P>
                    </ArrowLink>
                  </Pad>}
              </Description>
            </HeroText>
          </HFlexFlipper>
        </Section>
        <Card
          pictureAlign="right"
          picture={content.announcementCardImage.responsiveResolution.src}
          color="teal"
          title={
            <Flex>
              <span>
                {content.announcementTitle}
              </span>
            </Flex>
          }
          subtitle={content.announcementSubtitle}
          text={content.announcementBody.announcementBody}
        />
        <ContentSection
          join
          color="greyLight"
          titleText={content.ctaTitle}
          bodyText={content.ctaBody.ctaBody.split("|")}
          link={{
            label: content.ctaLink,
            to: "https://contraportal-2ec72.firebaseapp.com/"
          }}
        />
      </Background>
    </div>
  );
};

const enhance = withState("background", "onColorChange", "transparent");

export default enhance(TrialPage);

export const pageQuery = graphql`
  query TrialPageQuery {
    allContentfulTrialPage {
      edges {
        node {
          heroTitle
          heroBody {
            heroBody
          }
          heroImage {
            responsiveResolution(width: 800, quality: 70) {
              src
            }
          }
          heroLink
          announcementTitle
          announcementSubtitle
          announcementBody {
            announcementBody
          }
          announcementCardImage {
            responsiveResolution(width: 600, quality: 70) {
              src
            }
          }
          announcementLink
          ctaBody {
            ctaBody
          }
          ctaTitle
          ctaLink
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/trials.js